import { render } from "./prenotazioni.vue?vue&type=template&id=2569e067&ts=true"
import script from "./prenotazioni.vue?vue&type=script&lang=ts"
export * from "./prenotazioni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__